import PropTypes from 'prop-types';
import './styles.scss';

const StepsDots = ({
  className = '',
  current,
  total,
}) => {
  const steps = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className={`steps-dots ${className}`}>
      {steps.map((step) => (
        <div
          key={`step-${step}`}
          className={`step-dot ${step === current ? 'active' : ''} ${current > step ? 'done' : ''}`}
        />
      ))}
    </div>
  );
};

StepsDots.propTypes = {
  className: PropTypes.string,
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default StepsDots;
